export function compactText(value, max = 180) {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max - 1).trim()}…` : text;
}

export function formatLegalDate(value) {
  if (!value) return 'Needs date';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatRelativeTimestamp(value) {
  if (!value) return 'Just now';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  const diff = Date.now() - parsed.getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function getHealthTone(score) {
  if (score >= 75) {
    return {
      label: `Healthy · ${score}`,
      color: '#047857',
      background: 'rgba(5,150,105,0.12)',
      border: 'rgba(5,150,105,0.18)',
    };
  }
  if (score >= 45) {
    return {
      label: `Watch · ${score}`,
      color: '#b45309',
      background: 'rgba(217,119,6,0.12)',
      border: 'rgba(217,119,6,0.18)',
    };
  }
  return {
    label: `At risk · ${score}`,
    color: '#b91c1c',
    background: 'rgba(220,38,38,0.12)',
    border: 'rgba(220,38,38,0.18)',
  };
}

export function getSeverityTone(severity) {
  const normalized = String(severity || '').toLowerCase();
  if (normalized === 'high' || normalized === 'critical') {
    return { color: '#b91c1c', background: 'rgba(220,38,38,0.12)', border: 'rgba(220,38,38,0.18)' };
  }
  if (normalized === 'medium') {
    return { color: '#b45309', background: 'rgba(217,119,6,0.12)', border: 'rgba(217,119,6,0.18)' };
  }
  return { color: '#0f766e', background: 'rgba(15,118,110,0.12)', border: 'rgba(15,118,110,0.18)' };
}

export function getStatusTone(status) {
  const normalized = String(status || '').toLowerCase();
  if (['blocked', 'action_needed', 'pending', 'watch'].includes(normalized)) return getSeverityTone('medium');
  if (['done', 'ready', 'synced', 'accepted'].includes(normalized)) return getSeverityTone('low');
  return {
    color: 'var(--text-secondary)',
    background: 'rgba(148,163,184,0.12)',
    border: 'rgba(148,163,184,0.18)',
  };
}
